__webpack_require__.S = {};
const initPromises = {};
const initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	let initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	const scope = __webpack_require__.S[name];
	const warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	const uniqueName = "mutationsimportapp";
	const register = (name, version, factory, eager) => {
		const versions = scope[name] = scope[name] || {};
		const activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	const initExternal = (id) => {
		const handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			const module = __webpack_require__(id);
			if(!module) return;
			const initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			const initResult = initFn(module);
			if(initResult?.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	const promises = [];
	switch(name) {
		case "default": {
			register("@pd-ui/core", "2.69.0", () => (Promise.all([__webpack_require__.e(96), __webpack_require__.e(155), __webpack_require__.e(203), __webpack_require__.e(642), __webpack_require__.e(103), __webpack_require__.e(767)]).then(() => (() => (__webpack_require__(7305))))));
			register("@pd-ui/icons", "2.17.0", () => (Promise.all([__webpack_require__.e(96), __webpack_require__.e(155), __webpack_require__.e(642)]).then(() => (() => (__webpack_require__(5368))))));
			register("@tanstack/react-query", "4.44.0", () => (Promise.all([__webpack_require__.e(96), __webpack_require__.e(155)]).then(() => (() => (__webpack_require__(5306))))));
			register("i18next", "22.0.2", () => (__webpack_require__.e(96).then(() => (() => (__webpack_require__(402))))));
			register("jotai", "2.20.1", () => (Promise.all([__webpack_require__.e(96), __webpack_require__.e(155)]).then(() => (() => (__webpack_require__(9264))))));
			register("react-dom", "18.2.0", () => (Promise.all([__webpack_require__.e(96), __webpack_require__.e(155)]).then(() => (() => (__webpack_require__(961))))));
			register("react-i18next", "14.0.5", () => (Promise.all([__webpack_require__.e(96), __webpack_require__.e(155)]).then(() => (() => (__webpack_require__(3710))))));
			register("react-i18next", "14.1.3", () => (Promise.all([__webpack_require__.e(96), __webpack_require__.e(155)]).then(() => (() => (__webpack_require__(6559))))));
			register("react-router-dom", "6.14.1", () => (Promise.all([__webpack_require__.e(96), __webpack_require__.e(155)]).then(() => (() => (__webpack_require__(2648))))));
			register("react/jsx-runtime", "18.2.0", () => (Promise.all([__webpack_require__.e(96), __webpack_require__.e(155)]).then(() => (() => (__webpack_require__(4848))))));
			register("react", "18.2.0", () => (__webpack_require__.e(96).then(() => (() => (__webpack_require__(6540))))));
			initExternal(3635);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};